

import { getJson, postForm } from '../lib/http.js';

const BASKET_URL = '/api/basket.php';
const COUPON_URL = '/api/coupon.php';
const CHECKOUT_URL = '/api/checkout.php';
const CATALOG_URL = '/api/catalog.php';
const ORDER_URL = '/api/order.php';
const PERKS_URL = '/api/package-perks.php';




export function fetchBootstrap() {
  return getJson(CATALOG_URL);
}

export function fetchFeatured(limit = 4) {
  return getJson(CATALOG_URL, { action: 'featured', limit });
}

export function fetchCategory(slug) {
  return getJson(CATALOG_URL, { action: 'category', slug });
}

export function fetchPackagePerks(packageId) {
  return getJson(PERKS_URL, { package_id: packageId });
}




export function checkSession() {
  return postForm(BASKET_URL, { action: 'check' });
}

export function login(username) {
  return postForm(BASKET_URL, { action: 'login', username });
}

export function logout(csrfToken) {
  return postForm(BASKET_URL, { action: 'logout', csrf_token: csrfToken });
}



export function fetchBasket() {
  return postForm(BASKET_URL, { action: 'get' });
}

export function addPackage(packageId, csrfToken, quantity = 1) {
  return postForm(BASKET_URL, {
    action: 'add',
    type: 'package',
    package_id: packageId,
    qty: quantity,
    csrf_token: csrfToken,
  });
}

export function addGiftPackage(packageId, recipient, csrfToken, quantity = 1) {
  return postForm(BASKET_URL, { action: 'add', type: 'package', package_id: packageId, qty: quantity, gift_username: recipient, csrf_token: csrfToken });
}


export function setItemQuantity(packageId, quantity, csrfToken) {
  return postForm(BASKET_URL, {
    action: 'set_qty',
    package_id: packageId,
    qty: quantity,
    csrf_token: csrfToken,
  });
}

export function removeItem(packageId, csrfToken) {
  return postForm(BASKET_URL, { action: 'remove', package_id: packageId, csrf_token: csrfToken });
}

export function clearBasket(csrfToken) {
  return postForm(BASKET_URL, { action: 'clear', csrf_token: csrfToken });
}



export function applyCoupon(code, csrfToken) {
  return postForm(COUPON_URL, { action: 'apply', code, csrf_token: csrfToken });
}

export function removeCoupon(code, csrfToken) {
  return postForm(COUPON_URL, { action: 'remove', code, csrf_token: csrfToken });
}




export function createCheckout({ csrfToken }) {
  return postForm(CHECKOUT_URL, { csrf_token: csrfToken });
}




export function fetchOrder(orderId) {
  return getJson(ORDER_URL, { order_id: orderId });
}
